import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const createFormInstance = async (payload: Partial<IFormInstance>) => {
	const url = "/observations/instances/";

	const response = await cmsClient.post<IFormInstance>(url, payload);
	return response.data;
};

const useCreateObservationFormInstance = () => {
	const mutation = useMutation(createFormInstance);

	return mutation;
};

export default useCreateObservationFormInstance;
